import "core-js/modules/es6.object.assign";
import ConsoleMenu from './ConsoleMenu';
import { SubMenu, Item, Divider, Header, Menu, SecondaryMenu } from './styles';
/**
 * @public
 */

var StyledComponents = {
  SubMenu: SubMenu,
  Item: Item,
  Divider: Divider,
  Header: Header,
  Menu: Menu,
  SecondaryMenu: SecondaryMenu
};
/**
 * @public
 */

/**
 * @public
 */

var ExportedConsoleMenu = Object.assign(ConsoleMenu, {
  Item: Item,
  SubMenu: SubMenu,
  Divider: Divider
});
export default ExportedConsoleMenu;
export * from './ConsoleMenu';
export { ConsoleMenu };
export * from './ItemDescriptor';
export * from './RoutableMenuTypes';
export { Item, SubMenu, Divider, StyledComponents };